import React, { useRef, useEffect } from 'react';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { ResourceType } from '../../../types/resource';
import UserAvatar from '../../../User/Avatar';
import BasicUserName from '../../../User/BasicUserName';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
const UserList = ({ id, itemIdGenerator, streamId, users, selectedUserId, keyboardSelectedIndex = -1, isLoading, className, onItemClick, itemSuffix, showSuffixOnlyOnHover, emptyView = null })=>{
    const scrollableRef = useRef(null);
    useEffect(()=>{
        // here we handle scrolling to the selected element when navigating by keyboard
        const scrollable = scrollableRef.current;
        const selectedNode = scrollable === null || scrollable === void 0 ? void 0 : scrollable.querySelector(`[data-selected]`);
        if (!selectedNode || !scrollable || keyboardSelectedIndex < 0) {
            return;
        }
        if (selectedNode.offsetTop + selectedNode.offsetHeight < scrollable.scrollTop + scrollable.offsetHeight && selectedNode.offsetTop > scrollable.scrollTop) {
            return;
        }
        // position to bottom
        scrollable.scrollTop = selectedNode.offsetTop + selectedNode.offsetHeight - scrollable.offsetHeight;
    }, [
        scrollableRef,
        keyboardSelectedIndex
    ]);
    return /*#__PURE__*/ React.createElement(StreamedList, {
        id: id,
        role: "listbox",
        streamId: streamId,
        className: className,
        innerRef: (node)=>scrollableRef.current = node
    }, !isLoading && users.length === 0 && emptyView, users.map((user, index)=>{
        const isSelectedViaKeyboard = keyboardSelectedIndex === index;
        return /*#__PURE__*/ React.createElement("div", {
            id: itemIdGenerator ? itemIdGenerator(index) : undefined,
            role: "option",
            "aria-selected": isSelectedViaKeyboard,
            key: user.userId,
            "aria-label": user.username,
            "data-selected": isSelectedViaKeyboard ? 1 : undefined
        }, /*#__PURE__*/ React.createElement(ListItem, {
            prefix: /*#__PURE__*/ React.createElement(UserAvatar, {
                withTooltip: false,
                withLink: false,
                user: user,
                size: 40,
                "aria-hidden": "true"
            }),
            suffix: itemSuffix,
            showSuffixOnlyOnHover: showSuffixOnlyOnHover,
            label: /*#__PURE__*/ React.createElement(BasicUserName, {
                user: user
            }),
            isSelected: selectedUserId === user.userId || isSelectedViaKeyboard,
            onClick: onItemClick && (()=>onItemClick(user)),
            biData: BiData({
                evid: 402,
                typeid: ResourceType.USER,
                itemid: user.userId,
                sectionname: BiContextProvidedValue
            })
        }));
    }), isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, null));
};
UserList.displayName = 'UserList';
export default UserList;
